import { useAtom } from 'jotai'
import { loginModalAtom } from '@/stores/auth'
import { useEffect } from 'react'
import React, { useState } from 'react';
import { Modal, Input, Button, Checkbox, message, Form } from 'antd';
import styles from './LoginModal.module.css'; // 建议将样式抽离
import { getCodeApi, loginCodeApi } from '@/api/modules/login';

const PhoneLoginForm = ({
    loginAfter
}: any) => {
    const [countdown, setCountdown] = useState(0);
    const [phone, setPhone] = useState('');
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        let timer;
        if (countdown > 0) {
            timer = setTimeout(() => setCountdown(countdown - 1), 1000);
        }
        return () => clearTimeout(timer);
    }, [countdown]);

    // 发送验证码执行函数
    const handleSendCode = async () => {
        // 1. 手动校验：判断手机号是否为空
        if (!phone) {
            message.warning('请输入手机号');
            return;
        }

        // 2. 可选：正则校验手机号格式
        const phoneReg = /^1[3-9]\d{9}$/;
        if (!phoneReg.test(phone)) {
            message.error('请输入正确的手机号格式');
            return;
        }

        try {
            await getCodeApi(phone).then(() => {
                message.success('验证码已发送');
                setCountdown(60);
            })
        } catch (error) {
            message.error('发送失败，请稍后重试');
        }
    };


    const handleLogin = async () => {
        setLoading(true)
        await loginCodeApi({
            "phoneNumber": phone,
            "phoneCode": code,
            uniqueId: localStorage.getItem("fp_visitor_id")
        }).then((res) => {
            localStorage.setItem(import.meta.env.VITE_TOKEN_KEY, res.data)
            message.success('登录/注册成功');
            loginAfter()
        }).finally(() => {
            setLoading(false)
        })
    };
    return (
        <Form
            layout="vertical"
            onFinish={handleLogin}
            autoComplete="off"

            style={{ padding: "0 12px " }}
        >
            <Form.Item
                name="phone"
                rules={[{ required: true, message: '请输入手机号' }]}
            >
                <Input
                    size="large"
                    prefix={<span style={{ color: '#333', marginRight: 12 }}>+86</span>}
                    placeholder='请输入手机号'
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                />
            </Form.Item>

            <Form.Item
                name="code"
                rules={[{ required: true, message: '请输入验证码' }]}

            >
                <div className={styles.codeRow}> <Input
                    size="large" placeholder='请输入验证码' value={code}
                    onChange={(e) => setCode(e.target.value)}
                />
                    <Button className={styles.sendBtn} onClick={handleSendCode} disabled={countdown > 0}> {countdown > 0 ? `${countdown}s` : '发送验证码'}</Button>
                </div>

            </Form.Item>

            <Form.Item>
                <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    block
                    loading={loading}
                >

                    登录/注册
                </Button>

            </Form.Item>

        </Form>


    );
};

export default PhoneLoginForm;